import { Box, Button, Stack, Typography } from '@mui/material';
import { getFormularioSecretariaMunicipalAgriculturaByUUID } from 'api/forms/pacote_formularios.api';
import ContainerPainel from 'components/container_painel';
import { Loading } from 'components/login';
import { useAuth } from 'contexts/auth/auth_context';
import { UserPermissionEnum } from 'enum/userPermission.enum';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import { useFormularioSecretariaMunicipalAgriculturaStore } from 'stores/forms/formularioAgricultura.store';
import Step1 from './steps/step1';
import Step2 from './steps/step2';
import Step3 from './steps/step3';
import Step4 from './steps/step4';
import Step5 from './steps/step5';
import Step6 from './steps/step6';
import Step7 from './steps/step7';
import { FormSteps } from 'components/forms/form-steps';

const FormularioSecretariaMunicipalAgriculturaEditar: React.FC = () => {
  const { uuid } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();

  const usuariosPermitidos = [
    UserPermissionEnum.MUNICIPAL_MANAGER,
    UserPermissionEnum.ADMIN,
  ];

  const isUsuarioPermitido = usuariosPermitidos.includes(
    user?.permission.name as UserPermissionEnum,
  );

  const { formulario, setFormulario } =
    useFormularioSecretariaMunicipalAgriculturaStore();

  const getFormulario = async () => {
    const response = await getFormularioSecretariaMunicipalAgriculturaByUUID(
      uuid as string,
    );
    console.log(response);
    setFormulario(response.dados);
  };

  useEffect(() => {
    getFormulario();
  }, []);

  const steps = [
    'Informações Gerais',
    'Informações Complementares',
    'Servidores',
    'Estrutura',
    'Serviços Prestados',
    'Programa e Assistência Técnica',
    'Órgãos Estaduais',
  ]

  return (
    <ContainerPainel
      pagina='Formulário da Secretaria Municipal de Agricultura'
      showBackButton={true}
    >
      {isUsuarioPermitido ? (
        <Stack marginX={'4rem'} paddingTop={'2rem'}>
          <FormSteps
            activeStep={formulario?.step_atual ?? 0}
            edit={true}
            steps={steps}
          />

          {formulario ? (
            <>
              {formulario.step_atual === 1 && <Step1 />}
              {formulario.step_atual === 2 && <Step2 />}
              {formulario.step_atual === 3 && <Step6 />}
              {formulario.step_atual === 4 && <Step5 />}
              {formulario.step_atual === 5 && <Step4 />}
              {formulario.step_atual === 6 && <Step7 />}
              {formulario.step_atual === 7 && <Step3 />}
            </>
          ) : (
            <Box display={'flex'} justifyContent={'center'}>
              <Loading />
            </Box>
          )}
        </Stack>
      ) : (
        <Stack
          sx={{
            marginX: '4rem',
            paddingTop: '2rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            backgroundColor: '#FFF',
            borderRadius: '1rem',
            padding: '2rem',
            margin: '2rem',
          }}
        >
          <Typography>
            Você não tem permissão para editar este formulário
          </Typography>
          <Button onClick={() => navigate(ROUTES.PACOTE_FORMULARIOS)}>
            Voltar
          </Button>
        </Stack>
      )}
    </ContainerPainel>
  );
};

export default FormularioSecretariaMunicipalAgriculturaEditar;
